import { createTheme } from '@mui/material/styles';

const cpTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#08090d',
      paper: '#0d0f16',
    },
    primary: { main: '#3d7fff' },
    success: { main: '#00d4aa' },
    warning: { main: '#f5a623' },
    error: { main: '#ff4d6a' },
    secondary: { main: '#a78bfa' },
    text: {
      primary: '#e8ecf4',
      secondary: '#8b96b4',
      disabled: '#4a5470',
    },
    divider: '#1f2638',
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    h1: { fontFamily: '"Syne", sans-serif', fontWeight: 800 },
    h2: { fontFamily: '"Syne", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Syne", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Syne", sans-serif', fontWeight: 600 },
    h5: { fontFamily: '"Syne", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Syne", sans-serif', fontWeight: 600 },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#141824',
          border: '1px solid #1f2638',
          borderRadius: 14,
          transition: 'border-color 0.2s',
          '&:hover': { borderColor: '#2a3450' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundColor: '#0d0f16', backgroundImage: 'none' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontFamily: '"DM Mono", monospace', fontSize: 10, borderRadius: 10 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontFamily: '"DM Mono", monospace',
          fontSize: 10,
          letterSpacing: '0.8px',
          color: '#4a5470',
          textTransform: 'uppercase',
          borderBottom: '1px solid #1f2638',
        },
        body: {
          borderBottom: '1px solid rgba(255,255,255,0.03)',
          fontSize: 13,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontFamily: '"DM Sans", sans-serif', fontWeight: 500 },
      },
    },
  },
});

export default cpTheme;
